function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.6 15.6c3.8-3.5 8.4-5.3 13.7-5.4h49.6v39.3L49.5 49v157h157.1v-29h39.3v49.6c-.1 5.3-2.1 9.8-5.9 13.3-3.5 3.8-7.9 5.8-13.3 5.9H29.3c-5.4-.1-9.9-2.1-13.7-5.9-3.5-3.5-5.3-7.9-5.4-13.3V29.3c.1-5.3 1.9-9.9 5.4-13.7z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M118.2 157.9c-5 0-10-1.9-13.9-5.7-7.7-7.6-7.7-20.1-.1-27.8l74.6-75h-42.6c-10.8 0-19.6-8.8-19.6-19.6s8.8-19.6 19.6-19.6h85.9l2 .1c3.2-.3 6.4.1 9.5 1.4 7.3 3 12.1 10.2 12.1 18.1v90.3c0 10.8-8.8 19.6-19.6 19.6s-19.6-8.8-19.6-19.6V77.4l-74.4 74.8c-3.8 3.8-8.9 5.7-13.9 5.7z"
});

var SvgIconExternalLink = function SvgIconExternalLink(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 256 256"
  }, props), React.createElement("title", null, title), _ref2, _ref3);
};

export default SvgIconExternalLink;